//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import FeatureBanner from '~/components/feature/FeatureBanner';
import Class from '~/components/Class';
import Character from '~/components/feature/Character';
import Story from '~/components/feature/Story';
import Role from '~/components/feature/Role';

export default {
  name: 'Feature',

  components: {
    FeatureBanner,
    Class,
    Character,
    Story,
    Role,
  },

  data() {
    return {
      CDN: process.env.CDN,
      activeAnchorPoint: null,
      sections: [
        {
          id: 0,
          name: 'feature',
          anchorPoints: {
            pc: 980,
            mobile: 580,
          },
        },
        {
          id: 1,
          name: 'class',
          anchorPoints: {
            pc: 2100,
            mobile: 1570,
          },
        },
        {
          id: 2,
          name: 'character',
          anchorPoints: {
            pc: 3400,
            mobile: 2640,
          },
        },
        {
          id: 3,
          name: 'story',
          anchorPoints: {
            pc: 4830,
            mobile: 3620,
          },
        },
        {
          id: 4,
          name: 'role',
          anchorPoints: {
            pc: 5920,
            mobile: 4380,
          },
        },
      ],
      // settings for swiper
      swiperOption: {
        spaceBetween: 0,
        speed: 400,
        loop: false,
        loopedSlides: 5,
        resizeObserver: true,
        slidesPerView: 3,
        slideToClickedSlide: false,
        breakpoints: {
          751: {
            slidesPerView: 5,
          },
        },
        on: {
          click: (swiper, event) => {
            event.preventDefault();

            const activeAnchorPoint = swiper.clickedIndex % 5; // find out which slide that user click
            this.handleAutoScroll(activeAnchorPoint);
          },
        },
      },
    };
  },

  computed: {
    ...mapState(['isMobile']),
    isLoop: {
      get() {
        return (
          (this.isMobile && this.sections.length > 3) ||
          (!this.isMobile && this.sections.length > 5)
        );
      },
      set(val) {
        return val;
      },
    },
    queryAnchorPoint() {
      return Number(this.$route.query.active);
    },
  },

  watch: {
    isMobile: {
      handler(val) {
        this.isLoop =
          (val && this.sections.length > 3) ||
          (!val && this.sections.length > 5);

        if (this.$swiper && this.$swiper.params) {
          this.$swiper.params.loop = val;
        }
      },
      immediate: true,
    },
    queryAnchorPoint: {
      handler(val) {
        if (val >= 0) {
          this.activeAnchorPoint = val;
          this.$router.replace({ query: null });
          if (process.client) {
            this.handleAutoScroll(val);
          }
        }
      },
    },
  },

  mounted() {
    if (this.queryAnchorPoint) {
      this.scrollTimer = setTimeout(() => {
        this.handleAutoScroll(this.queryAnchorPoint, 'auto');
      }, 400);
    }
  },

  methods: {
    handleBtnNextClick() {
      this.$swiper.slideNext();
    },
    handleAutoScroll(activeAnchorPoint, behavior = 'smooth') {
      const { anchorPoints } = this.sections.find(
        (section) => section.id === activeAnchorPoint,
      ); // find out anchor point
      const ratio = document.documentElement.dataset.ratio;
      const anchorPoint = this.isMobile ? anchorPoints.mobile : anchorPoints.pc;
      const topbarHeight =
        process.env.REGION === 'th' || this.isMobile ? 0 : 43;

      window.scrollTo({
        top: anchorPoint * ratio + topbarHeight,
        behavior,
      });
    },
  },

  async validate({ store, query }) {
    const queryVerification = query.active ? Number(query.active) : true;
    let features = null;
    let classes = null;

    if (queryVerification || queryVerification >= 0) {
      [features, classes] = await Promise.all([
        store.dispatch('getFeatures'),
        store.dispatch('getClasses'),
      ]);
    }

    return (
      (queryVerification || queryVerification >= 0) && !!features && !!classes
    );
  },
};
